import { render } from "./CustomInputTextArea.vue?vue&type=template&id=438ad295&scoped=true"
import script from "./CustomInputTextArea.vue?vue&type=script&lang=js"
export * from "./CustomInputTextArea.vue?vue&type=script&lang=js"

import "./CustomInputTextArea.vue?vue&type=style&index=0&id=438ad295&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438ad295"]])

export default __exports__